import React from "react";
import styles from "./Cards.module.sass";

const Cards = ({ card }) => {
	return (
		<div className={styles.container}>
			{/* {data.map((e) => {
				return <Card data={e} key={e.id} />;
			})} */}
		</div>
	);
};

export const Card = ({ data }) => {
	console.log(data);
	return (
		<div className={styles.outer}>
			<div className={styles.bg} />
			<div className={styles.card}>
				<div className={styles.blackLine} />
				{data.brand === "visa" && (
					<img
						src="https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png"
						alt="logo"
					/>
				)}
				<svg className={styles.number} viewBox="0 0 145 17">
					<text x="0" y="17">
						**** **** **** {data.last4}
					</text>
				</svg>
				<svg className={styles.exp} viewBox="0 0 96 17">
					<text x="0" y="17">
						exp: {data.exp_month}/{data.exp_year}
					</text>
				</svg>
			</div>
		</div>
	);
};

export default Cards;
